import gql from 'graphql-tag';
import SUPPORT_CATEGORY_FRAGMENT from '../fragments/support-category';
import SUPPORT_TOPIC_FRAMENT from '../fragments/support-topic';
import TAG_FRAGMENT from '../fragments/tag';

const GET_SUPPORT_CATEGORY = gql`
  query getSupportCategory($where: SupportCategoryWhereInput!) {
    supportCategory(where: $where) {
      ...BaseSupportCategory
      supportTopics {
        ...BaseSupportTopic
        tags {
          ...BaseTag
        }
      }
    }
  }
  ${SUPPORT_CATEGORY_FRAGMENT}
  ${SUPPORT_TOPIC_FRAMENT}
  ${TAG_FRAGMENT}
`;

export default GET_SUPPORT_CATEGORY;
